<script>
export default {
  name: "DatePickerInLine",
  functional: true,
  props: {
    openDialog: {
      type: Function
    }
  },

  render(createElement, context) {
    let selectedRow = context.data.attrs.row;
    let element;
    element = createElement("el-button", {
      props: {
        type: "primary",
        size: "small"
      },
      domProps: {
        innerHTML: "Agregar Fecha"
      },
      nativeOn: {
        // eslint-disable-next-line no-unused-vars
        click: (event) => {
          context.props.openDialog(selectedRow);
        }
      }
    });
    return element;
  }
};
</script>
